import { Link, Tooltip as MUITooltip } from '@mui/material';

import TextOverflowTooltip from '@atom/components/common/tooltip/TextOverflowTooltip';
import colors from '@atom/styles/colors';
import fonts from '@atom/styles/fonts';
import { WorkOrderField } from '@atom/types/work';
import { DETAIL_FIELD_WIDTH } from '@atom/utilities/taskUtilities';

import classes from './workOrderFields.module.css';

interface Props {
  field: WorkOrderField;
  width?: string;
}

const WorkOrderHyperlinkField = ({ field, width }: Props) => {
  return (
    <div style={width ? { width } : undefined}>
      <div className={classes.hyperlinkTitle}>
        <TextOverflowTooltip
          width={width ?? DETAIL_FIELD_WIDTH}
          text={field.title}
          color={colors.neutral.dim}
          fontSize={fonts.sm}
        />
      </div>
      <MUITooltip title={field.hyperlink}>
        <Link href={field.hyperlink} target="_blank">
          {field.value}
        </Link>
      </MUITooltip>
    </div>
  );
};

export default WorkOrderHyperlinkField;
